import type { MarketRegime, RiskLevel } from '../types/marketAnalytics';

export interface RegimeThemeMeta {
  regime: MarketRegime;
  emoji: string;
  labelEn: string;
  labelAr: string;
  accent: string;
  accentSoft: string;
  glow: string;
}

export const REGIME_THEME: Record<MarketRegime, RegimeThemeMeta> = {
  CALM: {
    regime: 'CALM',
    emoji: '😌',
    labelEn: 'Calm',
    labelAr: 'هادئ',
    accent: '#3ecf8e',
    accentSoft: 'rgba(62, 207, 142, 0.14)',
    glow: 'rgba(62, 207, 142, 0.35)',
  },
  MOMENTUM: {
    regime: 'MOMENTUM',
    emoji: '🔥',
    labelEn: 'Momentum',
    labelAr: 'زخم',
    accent: '#ff8c42',
    accentSoft: 'rgba(255, 140, 66, 0.16)',
    glow: 'rgba(255, 140, 66, 0.4)',
  },
  EXTREME: {
    regime: 'EXTREME',
    emoji: '⚡',
    labelEn: 'Extreme',
    labelAr: 'متطرف',
    accent: '#ff4d6d',
    accentSoft: 'rgba(255, 77, 109, 0.18)',
    glow: 'rgba(255, 77, 109, 0.45)',
  },
  SLEEPY: {
    regime: 'SLEEPY',
    emoji: '😴',
    labelEn: 'Sleepy',
    labelAr: 'خامل',
    accent: '#8b9cb3',
    accentSoft: 'rgba(139, 156, 179, 0.14)',
    glow: 'rgba(139, 156, 179, 0.25)',
  },
};

export const RISK_LEVEL_COLORS: Record<RiskLevel, string> = {
  LOW: '#3ecf8e',
  MEDIUM: '#f0b429',
  HIGH: '#ff4d6d',
};

export function regimeMeta(regime: MarketRegime): RegimeThemeMeta {
  return REGIME_THEME[regime] || REGIME_THEME.CALM;
}

export function applyRegimeDocumentTheme(regime: MarketRegime | null | undefined): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const meta = regime ? regimeMeta(regime) : null;
  if (!meta) {
    root.removeAttribute('data-mmec-regime');
    root.style.removeProperty('--mmec-regime-accent');
    root.style.removeProperty('--mmec-regime-accent-soft');
    root.style.removeProperty('--mmec-regime-glow');
    return;
  }
  root.setAttribute('data-mmec-regime', meta.regime);
  root.style.setProperty('--mmec-regime-accent', meta.accent);
  root.style.setProperty('--mmec-regime-accent-soft', meta.accentSoft);
  root.style.setProperty('--mmec-regime-glow', meta.glow);
}

export const REGIME_BADGE_HIDDEN_KEY = 'mmec_regime_badge_hidden';
